
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6 7.179l-4.41 4.41a.836.836 0 01-.448.232c-.05.01-.063.009-.113.012H.972c-.05-.003-.064-.003-.114-.011a.834.834 0 01-.522-1.325c.03-.04.04-.049.075-.086l4.41-4.41-4.41-4.412c-.035-.037-.044-.045-.075-.085A.835.835 0 011.142.179a.836.836 0 01.362.157c.04.03.048.04.085.075L6 4.82l4.411-4.41c.037-.035.046-.044.086-.075a.835.835 0 011.051.036.837.837 0 01.116 1.132c-.03.04-.04.048-.074.085L7.179 6l4.41 4.411c.035.037.045.046.075.086a.836.836 0 01-.074 1.093.837.837 0 01-.448.232c-.05.008-.063.008-.113.011h-.057c-.05-.003-.063-.003-.113-.011a.836.836 0 01-.448-.232l-4.41-4.411z","fill":"#55585E"}})])
          )
        }
      }
    